/* ============
 * Embed Component
 * ============
 *
 * todo: add documentation here!
 */
import { mapGetters, mapMutations } from 'vuex';

export default {
  data() {
    return {
      emailTo: [],
      emailcc: this.ccEmail,
      previewMessage: this.message,
      previewSubject: this.subject,
      // ccChecked: this.cc,
      // ccCommonChecked: this.ccCommon,
      // previewUserEmail: this.userEmail,
      // previewCommonEmail: this.commonEmail,
      previewNotes: this.notes,
      attachmentServer: this.server,
      attachmentInit: this.initFiles,
    };
  },
  computed: {
    ...mapGetters({
      modalButtonLoading: 'modalButtonLoading',
    }),
    ccOptions() {
      if (this.ccEmail) {
        return this.ccEmail.map(item => (
          {
            id: item,
            email: item,
            name: item,
          }
        ));
      }
    },
    contactOptions() {
      if (this.contacts) {
        return this.contacts.map(contact => Object.assign({}, {
          id: contact.id,
          email: contact.email,
          name: `${contact.first_name} ${contact.last_name} <${contact.email}>`,
        }));
      }
    },
  },
  mounted() {
    if (this.server) {
      this.modifyFilepondView('addfile');
      this.modifyFilepondView('processfile');
    }
  },
  created() {
    if (this.contacts) {
      const accountingContact = this.contacts.find(contact => contact.contact_types.some(type => type.name === 'Accounting'));
      const primaryContact = this.contacts.find(contact => contact.contact_types.some(type => type.name === 'Primary'));
      if (this.isMultiSelected) {
        const tempContact = [];
        this.contacts.forEach((item) => {
          if (typeof item.email !== 'undefined' && item.email !== '') {
            tempContact.push(item.email);
          }
        });

        this.emailTo = tempContact;
      } else if (accountingContact) {
        this.emailTo = [accountingContact.email];
      } else if (primaryContact) {
        this.emailTo = [primaryContact.email];
      }
    }
    this.updatePreviewParam({ email_cc: this.emailcc });
  },
  methods: {
    ...mapMutations({
      updatePreviewParam: 'UPDATE_PREVIEW_PARAM',
    }),

    ccOptionFilter(filterValue, allOptions) {
      if (filterValue !== '') {
        if (this.validateEmail(filterValue)) jQuery('.ccEmail').removeClass('hidden');
        else jQuery('.ccEmail').addClass('hidden');
      }
    },

    modifyFilepondView(type) {
      const pond = document.querySelector('.filepond--root');
      pond.addEventListener(`FilePond:${type}`, (e) => {
        let url = e.detail.file.serverId;
        if (type === 'processfile') {
          url = url.substring(1, url.length - 1);
          url = url.replace(/\\\//g, '/');
        }
        if (url) {
          const newName = url.split('/').pop();
          jQuery(`#custom_${e.detail.file.id}`).remove();
          jQuery(`#filepond--item-${e.detail.file.id} .filepond--file`).append(`<a id="custom_${e.detail.file.id}" href="${url}" target="_blank" style="color:white;font-size:16px;"><i class="fa fa-2x fa-external-link-square" aria-hidden="true"></i></a>`);
          jQuery(`#filepond--item-${e.detail.file.id} .filepond--file-info .filepond--file-info-main`).text(newName);
        }
      });
    },

    validateEmail(email) {
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
  },

  props: {

    /**
     * Header Text
     */
    headerTexts: {
      type: Array,
      required: false,
    },

    /**
     * The message
     */
    message: {
      type: String,
      required: true,
    },

    /**
     * The subject
     */
    subject: {
      type: String,
      required: true,
    },

    /**
     * The user email
     */
    // userEmail: {
    //   type: String,
    //   required: false,
    // },

    /**
     * The cc
     */
    // cc: {
    //   type: Boolean,
    //   required: false,
    // },

    /**
     * The common email
     */
    // commonEmail: {
    //   type: String,
    //   required: true,
    // },

    /**
     * The cc common
     */
    // ccCommon: {
    //   type: Boolean,
    //   required: true,
    // },

    /**
     * The buttons to display under the body of the embedded frame
     */
    buttons: {
      type: Array,
      required: false,
    },

    /**
     * The links to display under the buttons
     */
    links: {
      type: Array,
      required: false,
    },

    /**
     * The attachments to display
     */
    attachments: {
      type: Array,
      required: false,
    },

    /**
     * The links to display under the buttons
     */
    notes: {
      type: String,
      required: false,
    },

    /**
     * The attachments to display
     */
    contacts: {
      type: Array,
      required: false,
    },

    /**
     * Allow input
     */
    isEmailInput: {
      type: Boolean,
      required: false,
    },

    /**
     * Allow multi Selected
     */
    isMultiSelected: {
      type: Boolean,
      required: false,
    },

    /**
     * The attachment server
     */
    server: {
      type: Object,
      required: false,
    },

    /**
     * The attachment init
     */
    initFiles: {
      type: Array,
      required: false,
    },

    /**
     * The emails cc
     */
    ccEmail: {
      type: Array,
      required: false,
    },
  },

  watch: {
    previewMessage() {
      this.updatePreviewParam({ message: this.previewMessage });
    },
    previewSubject() {
      this.updatePreviewParam({ subject: this.previewSubject });
    },
    // ccChecked() {
    //   this.updatePreviewParam({ cc: this.ccChecked });
    // },
    // ccCommonChecked() {
    //   this.updatePreviewParam({ ccCommon: this.ccCommonChecked });
    // },
    previewNotes() {
      this.updatePreviewParam({ notes: this.previewNotes });
    },
    emailTo() {
      this.updatePreviewParam({ email_to: this.emailTo });
    },
    emailcc() {
      this.updatePreviewParam({ email_cc: this.emailcc });
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/components/previewMessage/previewMessage.js